import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <VPNService />
      <Features />
      <Contact />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}
